const MODULE_NAME = 'fulcrum/containers/User/SubstituteSection'
const RESET_SUBSTITUTES = 'fulcrum/container/User/SubstituteSection/RESET_SUBSTITUTES'
const SAVE_SUBSTITUTES = 'fulcrum/container/User/SubstituteSection/SAVE_SUBSTITUTES'
const UPDATE_SUBSTITUTES = 'fulcrum/container/User/SubstituteSection/UPDATE_SUBSTITUTES'
const REMOVE_SUBSTITUTES = 'fulcrum/container/User/SubstituteSection/REMOVE_SUBSTITUTES'
const ADD_SUBSTITUTE = 'fulcrum/container/User/SubstituteSection/ADD_SUBSTITUTE'
const ADD_NEW_SUBSTITUTE = 'fulcrum/container/User/SubstituteSection/ADD_NEW_SUBSTITUTE'
const CLEAR_NEW_SUBSTITUTE = 'fulcrum/container/User/SubstituteSection/CLEAR_NEW_SUBSTITUTE'

const FETCH_SUBSTITUTES = 'fulcrum/container/User/SubstituteSection/FETCH_SUBSTITUTES'
const FETCH_SUBSTITUTES_ERROR = 'fulcrum/container/User/SubstituteSection/FETCH_SUBSTITUTES_ERROR'
const FETCH_SUBSTITUTES_START = 'fulcrum/container/User/SubstituteSection/FETCH_SUBSTITUTES_START'
const FETCH_SUBSTITUTES_SUCCESS = 'fulcrum/container/User/SubstituteSection/FETCH_SUBSTITUTES_SUCCESS'

const POST_SUBSTITUTES = 'fulcrum/container/User/SubstituteSection/POST_SUBSTITUTES'
const POST_SUBSTITUTES_START = 'fulcrum/container/User/SubstituteSection/POST_SUBSTITUTES_START'
const POST_SUBSTITUTES_SUCCESS = 'fulcrum/container/User/SubstituteSection/POST_SUBSTITUTES_SUCCESS'
const POST_SUBSTITUTES_ERROR = 'fulcrum/container/User/SubstituteSection/POST_SUBSTITUTES_ERROR'

const PATCH_SUBSTITUTES = 'fulcrum/container/User/SubstituteSection/PATCH_SUBSTITUTES'
const PATCH_SUBSTITUTES_START = 'fulcrum/container/User/SubstituteSection/PATCH_SUBSTITUTES_START'
const PATCH_SUBSTITUTES_SUCCESS = 'fulcrum/container/User/SubstituteSection/PATCH_SUBSTITUTES_SUCCESS'
const PATCH_SUBSTITUTES_ERROR = 'fulcrum/container/User/SubstituteSection/PATCH_SUBSTITUTES_ERROR'

const DELETE_SUBSTITUTES = 'fulcrum/container/User/SubstituteSection/DELETE_SUBSTITUTES'
const DELETE_SUBSTITUTES_START = 'fulcrum/container/User/SubstituteSection/DELETE_SUBSTITUTES_START'
const DELETE_SUBSTITUTES_SUCCESS = 'fulcrum/container/User/SubstituteSection/DELETE_SUBSTITUTES_SUCCESS'
const DELETE_SUBSTITUTES_ERROR = 'fulcrum/container/User/SubstituteSection/DELETE_SUBSTITUTES_ERROR'

export {
  MODULE_NAME,
  SAVE_SUBSTITUTES,
  REMOVE_SUBSTITUTES,
  RESET_SUBSTITUTES,
  UPDATE_SUBSTITUTES,
  FETCH_SUBSTITUTES,
  FETCH_SUBSTITUTES_START,
  FETCH_SUBSTITUTES_SUCCESS,
  FETCH_SUBSTITUTES_ERROR,
  POST_SUBSTITUTES,
  POST_SUBSTITUTES_START,
  POST_SUBSTITUTES_SUCCESS,
  POST_SUBSTITUTES_ERROR,
  PATCH_SUBSTITUTES,
  PATCH_SUBSTITUTES_START,
  PATCH_SUBSTITUTES_SUCCESS,
  PATCH_SUBSTITUTES_ERROR,
  DELETE_SUBSTITUTES,
  DELETE_SUBSTITUTES_START,
  DELETE_SUBSTITUTES_SUCCESS,
  DELETE_SUBSTITUTES_ERROR,
  ADD_SUBSTITUTE,
  ADD_NEW_SUBSTITUTE,
  CLEAR_NEW_SUBSTITUTE,
}
